import React, { useEffect } from 'react';
import { Stream } from '@cloudflare/stream-react';
import { tracking } from '@dashboard/lib/tracking';
import Spinner from './Spinner/Spinner';

export default function CFVideoEmbed({
  id,
  onVideoPlayed,
  name,
  videoProps = {},
}) {
  const [videoPlayed, setVideoPlayed] = React.useState(false);

  useEffect(() => {
    if (videoPlayed) {
      tracking.trackEvent('Video played', {
        name,
        id,
      });

      if (onVideoPlayed && typeof onVideoPlayed === 'function') {
        onVideoPlayed();
      }
    }
  }, [videoPlayed]);

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="relative h-0 overflow-hidden max-w-full pb-[56.25%]">
        <div className="absolute inset-0 flex h-full w-full">
          <Spinner className="m-auto" />
        </div>

        <Stream
          className="rounded-lg overflow-hidden"
          controls
          defaultTextTrack="en"
          src={id}
          onPlay={() => setVideoPlayed(true)}
          {...videoProps}
        />
      </div>
    </div>
  );
}
